/*
 * @Author: DQL
 * @Date: 2021-12-30 10:26:50
 * @LastEditors: DQL
 * @LastEditTime: 2022-01-28 17:11:27
 * @Description: file content
 */
import Vue from 'vue';

import BlrSelect from './BlrSelect/BlrSelect';
import SingleBlrSelect from './BlrSelect/SingleBlrSelect';
import ProcessComment from './processComment';

Vue.component('BlrSelect', BlrSelect);
Vue.component('SingleBlrSelect', SingleBlrSelect);
Vue.component('ProcessComment', ProcessComment);
